var impressum = "Impressum";
var privacy = "Personvern og juridisk";
var recallInfo = "Tilbakekallingsinformasjon";
var signOut = "Logg av";
var no_no = {
	impressum: impressum,
	privacy: privacy,
	recallInfo: recallInfo,
	signOut: signOut
};

export { no_no as default, impressum, privacy, recallInfo, signOut };
